// XXX COMPAT WITH 0.8.0

Oauth = OAuth;
